import AddButton from "components/ui/Button/AddButton/AddButton";
import { Link } from "react-router-dom";
import ComponentAccessControl from "components/essentials/ComponentAccessControl/ComponentAccessControl";
import {
    BRANCH_CREATE_PERMISSION,
    DEPENDENCY_READ_PERMISSION,
} from "components/dashboard/TrainSAM/Dependency/permissions";

const DowntimeGuideStep = ({
    downtimeCapsule,
    downtimeBranch,
    addDownTimeBranch,
}) => {
    const { classCapsuleEntryId, capsuleId } = downtimeCapsule;
    return (
        <div
            className='d-flex justify-content-between align-items-center'
            style={{ minHeight: "55px" }}>
            {downtimeBranch ? (
                <ComponentAccessControl baseResources={DEPENDENCY_READ_PERMISSION}>
                    <Link
                        to={{
                            pathname: `/t-sam/guide-downtime/view/${capsuleId}/${classCapsuleEntryId}`
                        }}>
                        <div className='text-primary fw-medium'>
                            View downtime guides
                        </div>
                    </Link>
                </ComponentAccessControl>
            ) : (
                <>
                    <span className='no-space me-2'>
                        No downtime guides added
                    </span>
                    <ComponentAccessControl baseResources={BRANCH_CREATE_PERMISSION}>
                        <AddButton
                            btnText={"Add downtime guide"}
                            otherClassName='justify-content-end me-2'
                            onClick={addDownTimeBranch}
                        />
                    </ComponentAccessControl>
                </>
            )}
        </div>
    );
};

export default DowntimeGuideStep;
